import { Shield, Award, MapPin, Clock, Users, Star } from "lucide-react";

const features = [
  {
    icon: Shield,
    title: "Trust & Transparency",
    description: "RERA approved projects with complete legal documentation and transparent pricing",
    highlight: "100% Legal Compliance"
  },
  {
    icon: Award,
    title: "Award-Winning Design",
    description: "Collaborations with internationally acclaimed architects and interior designers",
    highlight: "25+ Design Awards"
  },
  {
    icon: MapPin,
    title: "Prime Locations",
    description: "Strategic locations with excellent connectivity to business hubs and lifestyle centers",
    highlight: "Metro & Airport Access"
  },
  {
    icon: Clock,
    title: "Timely Delivery",
    description: "Proven track record of on-time project completion with quality construction",
    highlight: "98% On-Time Delivery"
  },
  {
    icon: Users,
    title: "Customer-Centric",
    description: "Dedicated relationship managers and 24/7 customer support for seamless experience",
    highlight: "10,000+ Happy Families"
  },
  {
    icon: Star,
    title: "Premium Amenities",
    description: "World-class facilities including clubhouse, spa, fitness center, and recreational areas",
    highlight: "50+ Lifestyle Amenities"
  }
];

const FeatureHighlights = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 animate-fade-up">
          <h2 className="font-display-bold text-4xl md:text-5xl text-primary mb-6">
            Why Choose Us
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Over two decades of excellence in creating premium living spaces 
            that exceed expectations and deliver exceptional value.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="group text-center p-8 rounded-xl bg-card border border-border hover:shadow-lg transition-all duration-300 animate-fade-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-luxury-muted rounded-full mb-6 group-hover:bg-luxury group-hover:text-luxury-foreground transition-colors duration-300">
                  <IconComponent className="h-8 w-8" />
                </div>
                
                <h3 className="font-display text-2xl text-primary mb-4 group-hover:text-luxury transition-colors">
                  {feature.title}
                </h3>
                
                <p className="text-muted-foreground leading-relaxed mb-4">
                  {feature.description}
                </p>
                
                <div className="inline-block bg-primary/5 text-primary px-4 py-2 rounded-full text-sm font-medium">
                  {feature.highlight}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureHighlights;